import styled from 'styled-components';

export const Container = styled.div``;

export const SortContainer = styled.div`
  display: inline-flex;
  align-items: center;
  height: ${({ theme }) => theme.yoga.spacing.medium}px;
  cursor: pointer;
  color: ${({ theme }) => theme.yoga.colors.primaryLight};
  padding: ${({ theme }) => theme.yoga.spacing.zero};
  position: relative;
`;

export const Icon = styled.div`
  margin-left: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
  display: flex;
  flex-direction: column;
`;

export const NoSortable = styled.div`
  align-items: center;
  display: inline-flex;
  height: ${({ theme }) => theme.yoga.spacing.medium - 2}px;
`;

export const NoSelected = styled.div`
  align-items: center;
  display: inline-flex;
  height: ${({ theme }) => theme.yoga.spacing.medium}px;
  cursor: pointer;
`;
